import type { PluginObject } from 'vue';

const EventBusPlugin: PluginObject<never> = {
  install(Vue) {
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$eventBus = new Vue();
  },
};

export default EventBusPlugin;
